export default __webpack_public_path__ + "static/media/Qe_13.2031bc0e.JPG";